import React, { Component } from 'react';
import '../styles/main.scss';
import logo from '../images/logoWhite.png';
import System from '../utils/system';

class VersionLock extends Component {
    render () {
        return (
            <div className='wrapper'>
                <div style={styles.background}>
                    <div className='auth-logo-wrapper'>
                        <img className='auth-logo' src={logo} alt='logo' />
                    </div>
                    <h1 style={styles.text}>
                        Atualize!
                    </h1>
                    {System.platform.web
                        ? <h4 style={styles.text}>
                            Seu jogo está em uma versão muito velha. Recarrege seu navegador ou baixe o aplicativo.
                        </h4>
                        : <h4 style={styles.text}>
                            Seu jogo está em uma versão muito velha. Atualize o aplicativo para continuar jogando.
                        </h4>
                    }
                    <div className='btn block login'
                         onClick={() => {
                             window.location = 'https://play.google.com/store/apps/details?id=io.appmasters.eisaquestao';
                         }}>
                        <h4>Google Play</h4>
                    </div>
                </div>
            </div>
        );
    }
}

// I'm sorry for this Max :(
const styles = {
    background: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#2b9b82',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '5%'
    },
    text: {
        color: '#FFF',
        marginHorizontal: 32
    }
};

export default VersionLock;



// WEBPACK FOOTER //
// ./src/views/versionLockView.js